import Vue from 'vue'
import Firebase from 'firebase/app'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Announcements from '@/views/Announcements.vue'
import Detentions from '@/views/Detentions.vue'
import NotFound from '@/views/NotFound.vue'
import AllStudents from '@/views/AllStudents.vue'
import StudentHistory from '@/views/StudentHistory.vue'

Vue.use(Router)

const router =  new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/announcements',
      name: 'announcements',
      component: Announcements,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/detentions',
      name: 'detentions',
      component: Detentions,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/students',
      name: 'allStudents',
      component: AllStudents,
      meta: {
        requiresAuth: true,
      }
    },
    {
      path: '/student/:id',
      name: 'studentHistory',
      component: StudentHistory,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/404',
      component: NotFound
    },
    {
      path: '*',
      redirect: '/404'
    },    
  ]
})

router.beforeEach((to, from, next) => {
  // "to/from" are router objects and matched is an array of route records
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const currentUser = Firebase.auth().currentUser;
  if (requiresAuth && !currentUser) {next('/')}
  else {next()}
});

export default router